export default {
    nREListOfMeasurementPoints:'测点清单',
    nreDeviceList:'设备列表',
    nredynamicEffectList:'动态效果列表',
    nredeviceMeasurement:'设备测点关联',
    nreassociativeMeasurementPoints:'关联测点',
    nreequipmentDynamicManagement:'设备动效管理',
    nremeasurementPointPanelManagement:'测点面板管理',
    nredynamicModelManagement:'动态模型管理',
    nreassociateDynamicModels:'关联动态模型',
    nrepanelManagement:'面板管理',  
}